export default function loadCustomFonts() {
    const cdnFonts = (window._CONFIG_?.cdnFonts || '/').replace(/\/$/, '');

    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      @font-face {
        font-family: 'Kievit Regular';
        src: url('${cdnFonts}/fonts/KievitWebPro-Book.eot');
        src: local('Kievit Regular'),
             url('${cdnFonts}/fonts/KievitWebPro-Book.woff') format('woff');
             font-display: swap;
      }
      @font-face {
        font-family: 'Kievit Medium';
        src: url('${cdnFonts}/fonts/KievitWebPro-Medi.eot');
        src: local('Kievit Medium'),
             url('${cdnFonts}/fonts/KievitWebPro-Medi.woff') format('woff');
             font-display: swap;
      }
      @font-face {
        font-family: 'Kievit Bold';
        src: url('${cdnFonts}/fonts/KievitWebPro-Bold.eot');
        src: local('Kievit Bold'),
             url('${cdnFonts}/fonts/KievitWebPro-Bold.woff') format('woff');
             font-display: swap;
      }
      @font-face {
        font-family: 'Kievit Light';
        src: url('${cdnFonts}/fonts/KievitWeb-Light.eot');
        src: local('Kievit Light'),
             url('${cdnFonts}/fonts/KievitWeb-Light.woff') format('woff');
             font-display: swap;
      }
    `;

    document.head.appendChild(style);
}
